import type { Message} from './Communication';

import { sendMessage } from './Communication';

type InitializationActions = 'started' | 'finished' | 'update' | 'progress-message';

interface InitializationArguments {
    message: string;
}

function sendInitializationMessage(action: InitializationActions, message?: string): void {
    let args: InitializationArguments | undefined;

    if (message != null) {
        args = {
            message
        };
    }

    return sendMessage<Message<InitializationArguments | undefined>>(
        {
            type: 'initialization',
            action,
            arguments: args
        },
        true
    );
}

export const startInitialization: (message?: string) => void = (message?: string) => sendInitializationMessage('started', message);
export const updateInitializationMessage: (message?: string) => void = (message?: string) => sendInitializationMessage('update', message);
export const setProgressMessage: (message?: string) => void = (message?: string) => sendInitializationMessage('progress-message', message);
export const finishInitialization: VoidFunction = (): void => sendInitializationMessage('finished');